var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiDeleteOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3779_33053",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V28H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0V28H41V0H39Z",
    fill: "#E2E2E2",
    mask: "url(#path-1-inside-1_3779_33053)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 19.8333C15.0003 20.2754 15.1759 20.6993 15.4885 21.0118C15.801 21.3244 16.225 21.5 16.667 21.5H23.3337C23.7757 21.5 24.1996 21.3244 24.5122 21.0118C24.8247 20.6993 25.0003 20.2754 25.0003 19.8333V9.83333H15.0003V19.8333ZM16.667 11.5H23.3337V19.8333H16.667V11.5ZM22.917 7.33333L22.0837 6.5H17.917L17.0837 7.33333H14.167V9H25.8337V7.33333H22.917Z",
    fill: "#DE0707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiDeleteOutline);
export default __webpack_public_path__ + "static/media/mdi_delete-outline.92f64b2a52a93e9fcbf18ce436c761bd.svg";
export { ForwardRef as ReactComponent };